import {toggleButton, ToggleButton} from "./toggle/ToggleComponent";
import ChartIQ from "./chartiq";
import Charts from "./charts";
import TradingView from "./tradeview";
import ColourPicker from "./colour-picker";
import Inputs from "./inputs";
import Quiz from "./quiz";
import Trade from "./trade";
import Watchlist from "./watchlist";
import UI from "./ui";
import {marketSummary, MarketSummary} from "./markets/MarketsSummaryComponent";
import {businessDatePicker, BusinessDatePicker} from "./business-date-picker/BusinessDatePickerComponent";
import DatePicker from "./date-picker";
import {courseOfSales, CourseOfSales} from "./course-of-sales/CourseOfSalesComponent";

const dependencies = [
    Charts,
    ChartIQ, // We need this for the quote service
    TradingView,
    ColourPicker,
    DatePicker,
    Inputs,
    Quiz,
    Trade,
    Watchlist,
    UI
];

export default angular.module("tfApp.components", dependencies)
                      .component(BusinessDatePicker, businessDatePicker())
                      .component(CourseOfSales, courseOfSales())
                      .component(MarketSummary, marketSummary())
                      .component(ToggleButton, toggleButton())
                      .name;
